import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_price_book_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  entity_code: fromDatatype.VarcharDatatypeInterface;
  entity_name: fromDatatype.VarcharDatatypeInterface;
  entity_type: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_mst_price_book_hdr_RowClass
  implements bl_fi_mst_price_book_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.NamespaceDataFieldInterface;
  app_id: fromDatatype.VarcharDatatypeInterface;
  conditional_filter_json: fromDatatype.JsonDatatypeInterface;
  price_book_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  usage_json: fromDatatype.JsonDatatypeInterface;
  pricing_bundle_json: fromDatatype.JsonDatatypeInterface;
  payment_logic_json: fromDatatype.JsonDatatypeInterface;
  descr: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  calculation_logic: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  branch_code: fromDatatype.VarcharDatatypeInterface;
  entity_guid: fromDatatype.GuidDataFieldInterface;
  entity_code: fromDatatype.VarcharDatatypeInterface;
  entity_name: fromDatatype.VarcharDatatypeInterface;
  entity_type: fromDatatype.VarcharDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
}
